import React, { Component } from 'react';

import './Creditos.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';
import renderHTML from 'react-render-html';
import $ from 'jquery';

import OwlCarousel from 'react-owl-carousel2';
import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images,
	relatorio_content
} from '../../settings';

class Creditos extends Component {

	constructor() {
		super();

        this.$ = $;

        this.images = images;
        this.relatorio_content = relatorio_content;

        this.state = {
            width: window.innerWidth
        };

	    this.scrollTop = this.scrollTop.bind(this);
	    this.globalTransition = this.globalTransition.bind(this);
	    this.animateWindow = this.animateWindow.bind(this);
	    this.reAnimateWindow = this.reAnimateWindow.bind(this);
	}

	scrollTop() {
		this.refs.contentText.scrollTop = 0;
	}

	animateWindow() { 
		var scrollSize = (this.$(".first__view .window_scroller").height() - this.$(".first__view .window").height());
		console.log(scrollSize);
		this.$(".first__view .window_scroller").stop().animate({ top: -scrollSize }, 15000, 'swing');
	}

	reAnimateWindow() {
		this.$(".first__view .window_scroller").stop().animate({ top: 0 }, 0, 'swing');
		this.animateWindow();
	}

    globalTransition() {
    	Actions.globalTransition();
    }

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('10 Créditos');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
        const { width } = this.state;
        const isMobile = width <= 769;

        if (!isMobile) {
			setTimeout(function() {
        		this.animateWindow();
			}.bind(this), 1000);
        }
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'creditos'
		];

		const monitor = (isMobile) ? this.images.creditos_monitor_mobile : this.images.creditos_user_icons;

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>10 Créditos - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>10</span> Créditos</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Créditos</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
				        		<div className="column">

		        					<p className="scroll_down">
		        						Desça e veja quem contribuiu<br />conosco em 2018<br />
		        						<img src={ this.images.creditos_arrow_down } />
		        					</p>

				        			<img src={ this.images.creditos_window } className="window_img" />

				        			<div className="window">
					        			<div className="window_scroller">

				        					<img src={ monitor } className="creditos_user_icons" />

				        					<div className="person_credit">
				        						<strong>Marcelo Billi</strong><br />
				        						<span>Gerência de Comunicação e Marketing</span>
				        					</div>

				        					<div className="person_credit">
				        						<strong>Amanda Brum</strong><br />
				        						<span>Coordenação digital</span>
				        					</div>

				        					<div className="person_credit">
				        						<strong>Marineide Marques</strong><br />
				        						<span>Coordenação de conteúdo</span>
				        					</div>

				        					<div className="person_credit">
				        						<strong>Paula Diniz</strong><br />
				        						<span>Redação e edição</span>
				        					</div>

				        					<div className="person_credit">
				        						<strong>Lucas Lucena</strong><br />
				        						<span>Projeto digital</span>
				        					</div>

				        					<div className="see_again" onClick={() => this.reAnimateWindow()}>
				        						<img src={ this.images.creditos_arrow_down } />
				        						<span>Ver novamente</span>
				        					</div>

					        			</div>
				        			</div>
				        		</div>
			        		</div>
			        	</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { Creditos };
